import type { FlaggedContent } from "@circle-react/types";

import { t } from "@/i18n-js/instance";
import {
  CHAT_ROOM_MESSAGE_TYPE,
  CONNECT_CONNECTION_TYPE,
} from "@/react/types/FlaggedContent";

const i18nRoot =
  "settings.moderation.review_flagged_content_modal.visibility_info";

export const useVisibilityDescription = (
  flaggedContent?: FlaggedContent,
): string | undefined => {
  const flaggedContentable = flaggedContent?.flagged_contentable;
  const type = flaggedContentable?.type;

  if (
    !flaggedContentable ||
    type === CONNECT_CONNECTION_TYPE ||
    type === CHAT_ROOM_MESSAGE_TYPE
  ) {
    return undefined;
  }

  const { flagged_for_approval_at, removed_at } = flaggedContentable;
  return flagged_for_approval_at || removed_at
    ? t([i18nRoot, "hidden_until_approved"])
    : t([i18nRoot, "visible_to_all_members"]);
};
